
'use client'

import { graphic } from 'echarts'
import Charts from '@component/echarts'
import { useMemo } from 'react'
import { each } from 'lodash-es'
import { toPrice } from '@utils'


export default function MarketCharts({
  data,
  dataType,
  yearLabel,
  isLoading
}) {

  const options = useMemo(() => {
    let res = null
    if (data && data.data.length > 0) {
      let xdata = []
      let ydata = []
      each(data.data, item => {
        xdata.push(item.year)
        ydata.push(item.value)
      })
      let isPrice = [1, 4].includes(dataType.value)
      res = {
        grid: {
          top: '10%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#F0F1F3'
            }
          },
          axisLabel: {
            formatter(v) {
              return isPrice ? toPrice(v) : `${v}%`
            }
          }
        },
        color: ['#FF8500'],
        series: [{
          data: ydata,
          type: 'line',
          // showSymbol: false,
          smooth: true,
          areaStyle: {
            color: graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(255, 133, 0, 0.29)'
            }, {
              offset: 1,
              color: 'rgba(255, 133, 0, 0)'
            }])
          }
        }]
      }
    }
    return res
  }, [data, dataType])

  if (isLoading) {
    return (
      <ChartsSkeleton></ChartsSkeleton>
    )
  }

  return (
    <div className='border pb-20'>
      <div className='h-350'>
        {options && <Charts options={options}></Charts>}
      </div>
      <div className='text-center text-sm mt-8'>
        {
          data && (
            <>
              <span className='text-secondary'>{data.growth}%</span>
              <span className='text-font ml-4'>{yearLabel} change</span>
            </>
          )
        }
      </div>
    </div>
  )
}

function ChartsSkeleton() {
  return (
    <div className='skeleton-wrap'>
      <span className='h-350'></span>
    </div>
  )
}